import React from "react";
import {ListSubheader, MenuItem} from "@mui/material";
import {isNotEmpty} from "../../shared/functions/types_check";

export const getGetCategory = (categories, childrenId) => {

    let selectedCategory = null;

    categories.forEach(category => {
        category.children.forEach(subCategory => {
            if (subCategory.id === childrenId) {
                selectedCategory = {
                    Id: category.id,
                    Label: category.label,
                    SubCategorie: {
                        Id: subCategory.id,
                        Label: subCategory.label,
                    }
                }
            }
        })
    })

    return selectedCategory;

}

export const renderCategoryOptions = (categories) => {
    let list = [];

    categories.forEach(category => {
        list.push(
            <ListSubheader key={category.id}>
                {category.label}
            </ListSubheader>
        )

        category.children.forEach(subCategory => {
            list.push(
                <MenuItem value={subCategory.id} key={subCategory.id}>
                    {subCategory.label}
                </MenuItem>
            )
        })

    })

    return list

}

export const getImages = (item) => {
    let list = [];

    if (item?.ImageUrl)
        list.push({
            preview: item?.ImageUrl
        })

    if (isNotEmpty(item?.Images)) {
        item?.Images.forEach(image => {
            list.push({
                preview: image
            })
        })
    }

    return list;
}
export const getVendors = (vendors) => {
    console.log(vendors,'get')

    let list = [];
    if (isNotEmpty(vendors)) {
        Object.entries(vendors).forEach(entry => {
            const [key, value] = entry;
            let data = {id: key, name: value.Name}
            list.push(data)


            console.log(entry, 'hh');
        });
        return list
    }else {
        return list
    }


    


      /*  for (const vendor in item?.Vendors)
            list.push({key: Object.keys(vendor) , value:vendor})*/

}